export const MiniQ2ValuesModel = {
    url_1: "-1",
    url_2: "-1",
    url_3: "-1",
    url_4: "-1",
}
export const MiniQ2HasModel = {
    has_url_1: false,
    has_url_2: false,
    has_url_3: false,
    has_url_4: false,
}